export class ShowError {
  public static readonly type = '[Error] Show error';

  public constructor(public message: string, public statusCode?: string) {}
}

export class RemoveOldestError {
  public static readonly type = '[Error] Remove oldest error';
}
